import { Component, input, output } from "@angular/core";
import { MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MatDivider } from "@angular/material/divider";

@Component({
  selector: "app-info-expansion-panel",
  templateUrl: "./info-expansion-panel.component.html",
  styleUrl: "./info-expansion-panel.component.scss",
  imports: [MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatDivider]
})
export class InfoExpansionPanelComponent {
  readonly removeClicked = output<void>();

  readonly title = input<string>(undefined);
  readonly icon = input<string>(undefined);

  remove(event: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.removeClicked.emit(undefined);
  }
}
